import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastService } from 'src/app/shared/services/toaster.service';

@Component({
  selector: 'app-o-auth-call-back',
  templateUrl: './o-auth-call-back.component.html',
  styleUrls: ['./o-auth-call-back.component.scss']
})
export class OAuthCallBackComponent implements OnInit {
  state = 'loading'

  constructor(private activatedRoute : ActivatedRoute,private apiService : ApiService,private router:Router,private toastService : ToastService) { }

  routeParams : {code : string , state:string} = { code : '' , state : ''}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((res:any)=>{
      const { code , state } = res
      this.routeParams.code = code
      this.routeParams.state = state
      this.getTheTokenDetails()
    })
  }

  getTheTokenDetails(){

    this.apiService.getOAuthTokenDetails({code : this.routeParams.code , state : this.routeParams.state}).subscribe((res:any)=>{
      this.state = 'success'
      const { refresh , access , is_new_user } = res?.data
      if(!access){
        this.toastService.presentToast('Failed to get the OAuth token', 'danger');
        this.router.navigate(['/login'])
        return
      }

      this.router.navigate(['auth',access])
    },(err:any)=>{
      this.state = 'failed'
    })
    
  }

  goToLogin(){
    this.router.navigate(['/login'])
  }

}
